import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttpService } from '../../api-http.service';
import { ClientInvoiceTotals, CustomHttpResponse } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ClientInvoiceTotalsService {
  apiService: ApiHttpService<ClientInvoiceTotals> = inject(ApiHttpService<ClientInvoiceTotals>);

  getForClientInvoice(iri: string): Observable<ClientInvoiceTotals> {
    return this.apiService.get(`${iri}/totals`).pipe(
      take(1),
      map((result: CustomHttpResponse<ClientInvoiceTotals>) => result.body),
    );
  }
}
